import React, { useEffect, useState } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { FaEye, FaFileInvoiceDollar } from 'react-icons/fa'
import { FaPrint } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { homeUrl } from '../../utils/api'
import { ConvertDate } from '../../utils/dateFormat'
import { svgs } from '../../utils/findSvgs/findSvgs'
import {
    filterOrderType,
    filterSortDelivery,
    filterSortOptions,
    filterSortOrder,
    filterSortPayment,
} from '../../utils/static/static'
import { InvoicePreview } from '../InvoicePDF/InvoicePreview'
import POSPreview from '../InvoicePDF/POSPreview'
import DatePicker from '../Resources/DatePicker/DatePicker'
import SkeletonLoader from '../Resources/SkeletonLoader/SkeletonLoader'
import TableV1 from '../Resources/TableV1/TableV1'
import TitleContainer from '../Resources/TitleContainer/TitleContainer'
import Action from './Action/Action'
import classes from './OrderList.module.css'
import Modal from './PDFModal/Modal'
import PopUp from './PopUpDropdown/PopUp'
import Popup from './Popup/Popup'
import SearchBar from './SearchBar'
import StatusPopup from './StatusPopup/StatusPopup'

const OrderList = ({
    products,
    loading,
    totalResults,
    setOrderNumber,
    orderProducts,
    loading1,
    updateProductStatus,
    setUpdateProductStatus,
    statusToggle,
    setStatusToggle,
    search,
    setSearch,
    filters,
    setFilters,
    setPage,
    handleDateChange,
}) => {
    const [meta, data] = products

    const [popup, setPopup] = useState(false)
    const [popupStatus, setPopupStatus] = useState(false)

    const [selectedOrder, setSelectedOrder] = useState(null)
    const [showInvoice, setShowInvoice] = useState(false)
    const [showPOS, setShowPOS] = useState(false)

    const handlePopup = () => {
        setPopup(!popup)
    }

    const handlePopupStatus = () => {
        setPopupStatus(!popupStatus)
    }

    function removeSpace(str) {
        return str.trim().toLowerCase().replace(/\s+/g, '-')
    }

    // for filters...

    const handleFilterChange = (label) => {
        setFilters((prev) => ({
            ...prev,
            all: false,
            [label]: filters[label] ? false : true,
        }))
    }

    const resetAll = () => {
        setFilters(() => ({
            ...filters,
            all: true,
            delivery: '',
            order: '',
            payment: '',
            showAll: true,
            custom: '',
        }))
        setSearch((prev) => ({
            ...prev,
            value: '',
            isSearchAble: false,
        }))
    }

    // for sorting...
    const onChange = (value) => {
        setFilters(() => ({ ...filters, sortBy: value }))
    }
    // for delivery...
    const onChangedelivery = (value) => {
        setFilters(() => ({ ...filters, delivery: value }))
    }
    // for order...
    const onChangeorder = (value) => {
        setFilters(() => ({ ...filters, order: value }))
    }
    // for payment...
    const onChangepayment = (value) => {
        setFilters(() => ({ ...filters, payment: value }))
    }

    useEffect(() => {
        if (data?.length <= 0) {
            setPage(0)
        }
    }, [data])

    return (
        <div className={classes.container}>
            <SearchBar search={search} setSearch={setSearch} />

            <div className={classes.sortContainerMobile}>
                {/* <PopUp
                    options={filterSortDelivery}
                    parentClass={'sortContainer'}
                    defaultValue={''}
                    placeholder={'Delivery Status'}
                    filters={filters}
                    onChange={onChangedelivery}
                /> */}

                <PopUp
                    options={filterSortPayment}
                    parentClass={'sortContainer'}
                    defaultValue={''}
                    placeholder={'Payment Status'}
                    filters={filters}
                    onChange={onChangepayment}
                />

                <PopUp
                    options={filterSortOrder}
                    parentClass={'sortContainer'}
                    defaultValue={''}
                    placeholder={'Order Status'}
                    filters={filters}
                    onChange={onChangeorder}
                />

                <PopUp
                    options={filterSortOptions}
                    parentClass={'sortContainer'}
                    defaultValue={''}
                    placeholder={'Sort By'}
                    filters={filters}
                    onChange={onChange}
                />
            </div>

            {/* Filters Row */}
            <div className={classes.filtersRow}>
                <div className={classes.formBox}>
                    <div className={classes.filtersdiv}>
                        {/* ---------- */}
                        <div className={classes.checkboxes}>
                            <div className={`${filters.all ? classes.active : ''}`} onClick={() => resetAll()}>
                                <div>{svgs.selectIcon}</div>
                                <label>All</label>
                            </div>
                            {/* {filterOrderType.map((type) => {
                                const isActive = Object.keys(filters).some((key) => key === type.label && filters[key])

                                return (
                                    <div
                                        key={type.id}
                                        className={`${isActive ? classes.active : ''}`}
                                        onClick={() => handleFilterChange(type.label)}>
                                        <div>{svgs.selectIcon}</div>
                                        <label>{type.value}</label>
                                    </div>
                                )
                            })} */}
                        </div>
                        {/* -------------- */}

                        {/* <div className={classes.sortContainer}>
                            <PopUp
                                options={filterSortDelivery}
                                parentClass={'sortContainer'}
                                defaultValue={''}
                                placeholder={'Delivery Status'}
                                filters={filters}
                                onChange={onChangedelivery}
                            />
                        </div> */}

                        <div className={classes.sortContainer}>
                            <PopUp
                                options={filterSortPayment}
                                parentClass={'sortContainer'}
                                defaultValue={''}
                                placeholder={'Payment Status'}
                                filters={filters}
                                onChange={onChangepayment}
                            />
                        </div>

                        <div className={classes.sortContainer}>
                            <PopUp
                                options={filterSortOrder}
                                parentClass={'sortContainer'}
                                defaultValue={''}
                                placeholder={'Order Status'}
                                filters={filters}
                                onChange={onChangeorder}
                            />
                        </div>

                        <DatePicker onDateChange={handleDateChange} />
                    </div>
                </div>

                <div className={classes.sortContainer}>
                    <PopUp
                        options={filterSortOptions}
                        parentClass={'sortContainer'}
                        defaultValue={''}
                        placeholder={'Sort By'}
                        filters={filters}
                        onChange={onChange}
                    />
                </div>
            </div>

            <TitleContainer title={'Order List'} isCount={true} count={totalResults} />
            <div>
                <TableV1>
                    <thead>
                        <tr className={`${classes.tableRow}`}>
                            <th>SL</th>
                            <th>Order No</th>
                            <th>Customer</th>
                            <th>Seller</th>
                            <th>Total Price(tk)</th>
                            <th>Quantity</th>
                            <th>Order Date</th>
                            {/* <th>Delivery</th> */}
                            <th>Order Status</th>
                            <th>Payment</th>
                            <th className={classes.actionHeader}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <SkeletonLoader row={10} column={11} />
                        ) : data.length > 0 ? (
                            data.map((item, index) => {
                                const { Order, OrderSeller, Seller, OrderShipment, OrderCommission } = item

                                return (
                                    <tr key={index} className={classes.tableData}>
                                        <td>{index + 1}</td>
                                        <td>{Order.order_number}</td>
                                        <td>
                                            {OrderShipment.customer_name} <br /> {OrderShipment.customer_phone}
                                        </td>
                                        <td>
                                            <Link
                                                to={`${homeUrl}/companies/${Seller.seller_full_id}/${removeSpace(
                                                    Seller.page_name
                                                )}`}
                                                className={classes.productShop}
                                                target="_blank">
                                                {Seller.page_name}
                                            </Link>
                                        </td>
                                        <td>{Order.payable_price}</td>
                                        <td>{Order.total_order_quantity || 0}</td>
                                        <td>{ConvertDate(Order.order_date)}</td>
                                        {/* <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    OrderShipment.shipment_status === 'delivered'
                                                        ? classes.completed
                                                        : OrderShipment.shipment_status === 'pending'
                                                        ? classes.pending
                                                        : OrderShipment.shipment_status === 'inProgress'
                                                        ? classes.inProgress
                                                        : OrderShipment.shipment_status === 'cancelled'
                                                        ? classes.cancelled
                                                        : ''
                                                }`}>
                                                {OrderShipment.shipment_status}
                                            </span>
                                        </td> */}

                                        <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    Order.order_status === 'delivered'
                                                        ? classes.completed
                                                        : Order.order_status === 'pending'
                                                        ? classes.pending
                                                        : Order.order_status === 'processing'
                                                        ? classes.inProgress
                                                        : Order.order_status === 'cancelled'
                                                        ? classes.cancelled
                                                        : Order.order_status === 'in_transit'
                                                        ? classes.transit
                                                        : Order.order_status === 'returned'
                                                        ? classes.returned
                                                        : ''
                                                }`}>
                                                {Order.order_status === 'in_transit'
                                                    ? 'In Transit'
                                                    : Order.order_status}
                                            </span>
                                        </td>

                                        <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    Order.payment_status === 'completed'
                                                        ? classes.completed
                                                        : Order.payment_status === 'pending'
                                                        ? classes.pending
                                                        : Order.payment_status === 'processing'
                                                        ? classes.inProgress
                                                        : Order.payment_status === 'cancelled'
                                                        ? classes.cancelled
                                                        : ''
                                                }`}>
                                                {Order.payment_status}
                                            </span>
                                        </td>

                                        <td className={classes.action}>
                                            {/* <Action setPopup={setPopup} popup={popup} /> */}
                                            <button
                                                title="view"
                                                className={classes.viewIcon}
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    handlePopup()
                                                }}>
                                                <FaEye size={16} />
                                            </button>

                                            <button
                                                title="edit"
                                                className={classes.editIcon}
                                                onClick={() => {
                                                    setUpdateProductStatus(item)
                                                    handlePopupStatus()
                                                }}>
                                                <AiFillEdit size={16} />
                                            </button>

                                            <button
                                                title="invoice"
                                                className={classes.invoiceIcon}
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    setSelectedOrder(item)
                                                    setShowInvoice(true)
                                                }}>
                                                <FaFileInvoiceDollar size={16} />
                                            </button>

                                            <button
                                                title="label"
                                                className={classes.posIcon}
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    setSelectedOrder(item)
                                                    setShowPOS(true)
                                                }}>
                                                <FaPrint />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="12" className={classes.tableNotFound}>
                                    <h2>No Data Found</h2>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </TableV1>
            </div>
            {popup && <Popup setForm={setPopup} form={popup} orderProducts={orderProducts} loading1={loading1} />}
            {popupStatus && (
                <StatusPopup
                    setForm={setPopupStatus}
                    form={popupStatus}
                    updateProductStatus={updateProductStatus}
                    statusToggle={statusToggle}
                    setStatusToggle={setStatusToggle}
                />
            )}

            {showInvoice && selectedOrder && (
                <Modal onClose={() => setShowInvoice(false)} invoiceNumber={selectedOrder.Order?.order_number}>
                    <InvoicePreview
                        invoiceNumber={selectedOrder.Order?.order_number}
                        date={ConvertDate(selectedOrder.Order?.order_date)}
                        clientName={selectedOrder.OrderShipment?.customer_name}
                        orderProducts={orderProducts}
                        selectedOrder={selectedOrder}
                    />
                </Modal>
            )}

            {showPOS && selectedOrder && (
                <Modal onClose={() => setShowPOS(false)} invoiceNumber={selectedOrder.Order?.order_number}>
                    <POSPreview
                        invoiceNumber={selectedOrder.Order?.order_number}
                        date={ConvertDate(selectedOrder.Order?.order_date)}
                        clientName={selectedOrder.OrderShipment?.customer_name}
                        orderProducts={orderProducts}
                        selectedOrder={selectedOrder}
                    />
                </Modal>
            )}
        </div>
    )
}

export default OrderList
